import { HttpClient, HttpErrorResponse, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

@Injectable()
export class StaticService {
    apiUrl = 'api/static';

    httpOptions = {
        headers: new HttpHeaders({
            'Cache-Control': 'no-cache',
            Pragma: 'no-cache'
        })
    };

    constructor(
        private httpClient: HttpClient,
    ) {
    }


    getStaticData(): Observable<any> {
        return this.httpClient.get(this.apiUrl, this.httpOptions);
    }

}
